export const TOKENS_PORTION = 6;

export const phoneMedia = "(max-width: 360px)";
